import { inject, Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

export const APP_TOAST_KEY = "app-toast";

@Injectable({
    providedIn: "root"
})
export class NotificationService {
    private readonly key = APP_TOAST_KEY;
    private readonly messageService = inject(MessageService);

    public success(text: string): void {
        this.notify("success", "Success", text);
    }

    public error(text: string): void {
        this.notify("error", "Error", text);
    }

    public warning(text: string): void {
        this.notify("warn", "Warning", text);
    }

    public notice(text: string): void {
        this.notify("info", "Notice", text);
    }

    private notify(severity: string, summary: string, detail: string): void {
        this.messageService.add({ key: this.key, severity, summary, detail, life: 5000, icon: " " });
    }
}
